import React from 'react';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
        
        {<video src='/videos/video-world.mp4' autoPlay loop muted/>}

        <h1>AURA ROUSSE</h1>
        <p>Leverage the full potential of AWS, Azure, Google Cloud, and expert full-stack development to transform your business.</p>
        
        <div className='hero-btns'>
          <a href= "#about">
            { <Button className='btns' buttonStyle='btn--outline'
            buttonSize='btn--large'>
                LEARN MORE
            </Button> }
            </a>


            {/* { <Button className='btns' buttonStyle='btn--primary'
            buttonSize='btn--large'>
                WATCH TRAILER <i className='far fa-play-circle'/>
            </Button> } */}
        </div>
    </div>
  )
}

export default HeroSection